import type { HTMLAttributes } from 'react'
import React from 'react'
import { csx, cx } from '@vtex/admin-ui'

export type PageAdvertisementsProps = HTMLAttributes<HTMLDivElement>

export const PageAdvertisements = ({
  className = '',
  children,
  ...props
}: PageAdvertisementsProps) => (
  <div
    className={cx(
      csx({
        paddingLeft: '$space-6',
        marginY: '$space-8',
        '@tablet': {
          paddingX: '$space-8',
        },
        '@desktop': {
          paddingX: '3.75rem',
        },
      }),
      className
    )}
    {...props}
  >
    <div className={csx({ maxWidth: '82.5rem', marginX: 'auto' })}>
      {children}
    </div>
  </div>
)
